import * as types from "./alvara.actionTypes";

export default {
  validarAlvara: data => ({
    type: types.ALVARA_VALIDAR,
    payload: data
  }),
  getAlvara: data => ({
    type: types.ALVARA_GET,
    payload: data
  }),
  setAlvara: data => ({
    type: types.ALVARA_SET,
    payload: data
  }),
  imprimirAlvara : (data, isImpressaoDireta) => ({
    type: types.ALVARA_IMPRIMIR,
    payload: {data, isImpressaoDireta}
  }),
}
